module.exports = __webpack_public_path__ + "img/icono-experiencia-6.138ca602.svg";